import { Button, Menu, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CustomizeIcon from "assets/icons/CustomizeIcon";
import { IOSSwitch } from "components/Input/switch";
import { useDispatch, useSelector } from "react-redux";
import { appSetTableColumns, appSetTableOrder } from "store/actions/appAction";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const EditColumnsContainer = styled("div")({
  width: "244px",
  // padding: '10px'
});
const RightItem = styled("div")({
  display: "flex",
  alignItems: "center",
});
const TitleContainer = styled("div")({
  height: "44px",
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
});
const BottomSection = styled("div")({
  height: "64px",
  display: "flex",
  borderTop: "1px solid #ABBACC",
  alignItems: "center",
  padding: "0 12px",
});
const AcceptButton = styled(Button)({
  height: "40px",
  width: "80px",
  display: "flex",
  alignItems: "center",
});
const RejectButton = styled(Button)({
  height: "40px",
  width: "65px",
  display: "flex",
  alignItems: "center",
});
const MiddleComponent = styled("div")({
  maxHeight: "250px",
  overflowY: "scroll",
});

interface hoverInterface {
  hovered: boolean;
}

const CustomizeItemContainer = styled("div")<hoverInterface>(({ theme, hovered }) => ({
  border: hovered ? "1px solid #ABBACC" : "unset",
  backgroundColor: "white",
  height: "44px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: 4,
  margin: "0 10px",
  marginBottom: "11px",
}));

const CustomizeItems = [
  {
    title: "کدحسابداری",
    value: "accounting-code",
  },
  {
    title: "کدحسابداری",
    value: "accounting-code",
  },
  {
    title: "کدحسابداری",
    value: "accounting-code",
  },
  {
    title: "کدحسابداری",
    value: "accounting-code",
  },
];

const EditColumns = ({
  anchorEl,
  handleClose,
  titles,
  selectedTitles,
  tabKey,
}: {
  anchorEl?: HTMLElement | null;
  handleClose: () => void;
  titles: any[];
  tabKey: string;
  selectedTitles: any[];
}) => {
  const open = Boolean(anchorEl);

  const [selected, setSelected] = useState(selectedTitles);

  const tableColumns = useSelector((state: any) => state).appReducer.tableColumns || [];

  const handleSwitchChange = (element: any) => {
    const index = selected.findIndex((it) => it.key === element.key);

    if (index === -1) return setSelected([...selected, element]);

    return setSelected(selected.filter((it) => it.key !== element.key));
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appSetTableColumns(tabKey, titles, tableColumns));
  }, []);

  useEffect(() => {
    dispatch(appSetTableColumns(tabKey, selected, tableColumns));
  }, [selected]);

  const onSubmit = () => {
    dispatch(appSetTableColumns(tabKey, selected, tableColumns));
    return handleClose();
  };

  return (
    <Menu
      id="demo-positioned-menu"
      aria-labelledby="demo-positioned-button"
      anchorEl={anchorEl}
      open={open}
      sx={{
        // left: "55px",
        top: "40px",
        "& div": {
          "& ul": {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      }}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      disableScrollLock
    >
      <EditColumnsContainer>
        <TitleContainer>
          <Typography variant="body2" mr={1} textAlign="right" color="#ABBACC">
            :ویرایش ستون ها
          </Typography>
        </TitleContainer>
        <MiddleComponent>
          <DragComponent
            titles={titles}
            selectedTitles={selectedTitles}
            handleSwitchChange={handleSwitchChange}
            selected={selected}
            tabKey={tabKey}
          />
        </MiddleComponent>
        {/*<BottomSection>*/}
        {/*    <AcceptButton variant="contained"*/}
        {/*                  disableElevation*/}
        {/*                  disableRipple*/}
        {/*                  onClick={onSubmit}*/}
        {/*    >*/}
        {/*        ذخیره*/}
        {/*    </AcceptButton>*/}
        {/*    <RejectButton variant="outlined" color="disabled"*/}
        {/*                  disableElevation*/}
        {/*                  disableRipple*/}
        {/*                  onClick={handleClose}*/}
        {/*                  sx={{ ml: '12px' }}*/}
        {/*    >*/}
        {/*        لغو*/}
        {/*    </RejectButton>*/}
        {/*</BottomSection>*/}
      </EditColumnsContainer>
    </Menu>
  );
};

export default EditColumns;

// a little function to help us with reordering the result
const reorder = (list: any, startIndex: any, endIndex: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getTableOrder = (tableOrders: any[], tabKey: string) => {
  try {
    const tableOrderIndex = tableOrders.findIndex((item) => item.key === tabKey);
    if (tableOrderIndex === -1) return null;
    return tableOrders[tableOrderIndex].columns;
  } catch {
    return null;
  }
};

const DragComponent = ({
  titles,
  selectedTitles,
  handleSwitchChange,
  selected,
  tabKey,
}: {
  titles: any[];
  selectedTitles: any[];
  handleSwitchChange: (element: any) => void;
  selected: any[];
  tabKey: string;
}) => {
  const [items, setItems] = useState(titles);

  const dispatch = useDispatch();

  const tableOrders = useSelector((state: any) => state).appReducer.tableOrders || [];

  useEffect(() => {
    const tableOrder = getTableOrder(tableOrders, tabKey);
    if (tableOrder) return setItems(tableOrder);
  }, []);

  useEffect(() => {
    dispatch(appSetTableOrder(tabKey, items, tableOrders));
  }, [items]);
  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const newItems = reorder(items, result.source.index, result.destination.index);
    return setItems(newItems);
  };

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity

  const [hovered, setHovered] = useState(Array(CustomizeItems.length).fill(false));
  const setEnter = (key: number) => {
    hovered[key] = true;
    return setHovered([...hovered]);
  };
  const setLeave = (key: number) => {
    hovered[key] = false;
    return setHovered([...hovered]);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {items.map((item, index) => (
              <Draggable key={item.name} draggableId={item.name} index={index}>
                {(provided, snapshot) => (
                  <CustomizeItemContainer
                    sx={{ p: 1 }}
                    hovered={hovered[index] || snapshot.isDragging}
                    onMouseEnter={() => setEnter(index)}
                    onMouseLeave={() => setLeave(index)}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    {selectedTitles && (
                      <IOSSwitch
                        defaultChecked={selectedTitles.find((it) => it.key === item.key)}
                        checked={selected.find((it) => it.key === item.key)}
                        onChange={() => handleSwitchChange(item)}
                      />
                    )}
                    <RightItem>
                      <Typography variant="body2" mr={1} textAlign="right">
                        {item.name}
                      </Typography>
                      <CustomizeIcon />
                    </RightItem>
                  </CustomizeItemContainer>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
